/** The user guide is public and lives at this path of the HO web app. */
export const DOCS_PATH = '/docs';

/** True for /docs and everything under it; the host mounts the guide before its login gate for these. */
export const isDocsPath = (pathname: string) => pathname === DOCS_PATH || pathname.startsWith(`${DOCS_PATH}/`);
